module.exports = __webpack_public_path__ + "img/product-03.71724d6b.jpg";